import { Button, Checkbox, Col, Row, Tag, TimePicker } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import "./ShiftTimingForm.less";

export const ShiftTimingForm = ({
  openingTime,
  closingTime,
  currentRoleIndex,
  currentEmployeeIndex,
  formInstance,
  initialValue,
  closeDropDown,
}) => {
  useEffect(() => {
    if (initialValue?.length > 0) {
      let stateUpdateValue = [];
      scheduleList.forEach(({ workingDay }) => {
        let currentInitialValueIndex = initialValue.findIndex(
          ({ working_day }) => {
            return workingDay?.trim() === working_day.trim();
          }
        );
        if (currentInitialValueIndex > -1) {
          stateUpdateValue.push({
            workingDay: initialValue[currentInitialValueIndex].working_day,
            start_time: moment().set({
              hours: initialValue[currentInitialValueIndex].start_time
                .split("+")[0]
                .split(":")[0],
              minutes: initialValue[currentInitialValueIndex].start_time
                .split("+")[0]
                .split(":")[1],
            }),
            end_time: moment().set({
              hours: initialValue[currentInitialValueIndex].end_time
                .split("+")[0]
                .split(":")[0],
              minutes: initialValue[currentInitialValueIndex].end_time
                .split("+")[0]
                .split(":")[1],
            }),
            checked: true,
            start_time_errors: {
              required: false,
              afterEnd: false,
              beforeOpening: false,
            },
            end_time_errors: {
              required: false,
              afterClosing: false,
            },
          });
        } else {
          stateUpdateValue.push({
            workingDay,
            checked: false,
            start_time_errors: {
              required: false,
              afterEnd: false,
              beforeOpening: false,
            },
            end_time_errors: {
              required: false,
              afterClosing: false,
            },
          });
        }
      });

      setScheduleList(stateUpdateValue);
    }
  }, []);

  const [scheduleList, setScheduleList] = useState([
    { workingDay: "Monday", checked: false },
    { workingDay: "Tuesday", checked: false },
    { workingDay: "Wednesday", checked: false },
    { workingDay: "Thursday", checked: false },
    { workingDay: "Friday", checked: false },
    { workingDay: "Saturday", checked: false },
    { workingDay: "Sunday", checked: false },
  ]);

  const onCheckboxChange = ({ isChecked, index, field }) => {
    field.checked = isChecked;
    field.start_time = isChecked
      ? moment().set({
          hours: openingTime.split("+")[0].split(":")[0],
          minutes: openingTime.split("+")[0].split(":")[1],
        })
      : null;
    field.end_time = isChecked
      ? moment().set({
          hours: closingTime.split("+")[0].split(":")[0],
          minutes: closingTime.split("+")[0].split(":")[1],
        })
      : null;
    field.start_time_errors = {};
    field.end_time_errors = {};
    scheduleList[index] = field;
    setScheduleList([...scheduleList]);
  };

  const handleTimeChange = ({ field, index, time, type }) => {
    field[type] = time;
    scheduleList[index] = field;
    const start_hours = openingTime ? parseInt(openingTime.split("+")[0].split(":")[0], 0) : 0;
    const end_hours = closingTime ? parseInt(closingTime.split("+")[0].split(":")[0], 0) : 0;
    const startHour = moment(scheduleList[index].start_time).hour();
    const endHour = moment(scheduleList[index].end_time).hour();
    if (scheduleList[index].start_time && scheduleList[index].end_time && (startHour >= start_hours && startHour <= end_hours) && endHour >= start_hours && endHour <= end_hours) {
      scheduleList[index].checked = true;
    } else {
      field.start_time = openingTime
      ? moment().set({
          hours: openingTime.split("+")[0].split(":")[0],
          minutes: openingTime.split("+")[0].split(":")[1],
        })
      : null;
    field.end_time = closingTime
      ? moment().set({
          hours: closingTime.split("+")[0].split(":")[0],
          minutes: closingTime.split("+")[0].split(":")[1],
        })
      : null;
    field.start_time_errors = {};
    field.end_time_errors = {};
    scheduleList[index] = field;
    }
    setScheduleList([...scheduleList]);
  };

  const getDisabledHours = () => {
    if(openingTime && closingTime){
    const start_hours = parseInt(openingTime.split("+")[0].split(":")[0], 0);
    const end_hours = parseInt(closingTime.split("+")[0].split(":")[0], 0);
    const result = [];
    for (let i = start_hours; i <= end_hours; i++) {
      result.push(i);
    }
    const filtered = [];
    for (let i = 0; i <= 24; i++) {
      if(result.some((val) => {return val === i})) {}
      else {
      filtered.push(i);
      }
    }
    return filtered;
  }
  }

  const validateTime = () => {
    let checkedDays = scheduleList.filter((s) => {
      return s.checked;
    });
    let isInvalid = false;
    checkedDays.forEach((cd) => {
      cd.start_time_errors = {};
      cd.end_time_errors = {};
      //Validate for Empty
      if (!cd.start_time) {
        cd.start_time_errors.required = true;
      } else {
        cd.start_time_errors.required = false;
      }
      if (!cd.end_time) {
        cd.end_time_errors.required = true;
      } else {
        cd.end_time_errors.required = false;
      }

      if (cd.start_time && cd.end_time) {
        // Validate if Start Time is after End time
        if (
          cd.start_time
            .set({ seconds: 0 })
            .isAfter(cd.end_time.set({ seconds: 0 }))
        ) {
          cd.start_time_errors.afterEnd = true;
        } else {
          cd.start_time_errors.afterEnd = false;
        }

        // // Validate if Start Time is before business opening time
        // if (
        //   cd.start_time
        //     .set({
        //       seconds: 59,
        //     })
        //     .isBefore(
        //       moment().set({
        //         hours: openingTime.split("+")[0].split(":")[0],
        //         minutes: openingTime.split("+")[0].split(":")[1],
        //         seconds: 0,
        //       })
        //     )
        // ) {
        //   cd.start_time_errors.beforeOpening = true;
        // } else {
        // cd.start_time_errors.beforeOpening = false;
        // }

        // Validate if End Time is after business closing time
        // if (
        //   cd.end_time.set({ seconds: 0 }).isAfter(
        //     moment().set({
        //       hours: closingTime.split("+")[0].split(":")[0],
        //       minutes: closingTime.split("+")[0].split(":")[1],
        //       seconds: 59,
        //     })
        //   )
        // ) {
        //   cd.end_time_errors.afterClosing = true;
        // } else {
        //   cd.end_time_errors.afterClosing = false;
        // }
        cd.start_time_errors.beforeOpening = false;
        cd.end_time_errors.afterClosing = false;
      }

      //Check if all error values are false
      let errorNotExists =
        Object.keys(cd.start_time_errors).every((k) => {
          return cd.start_time_errors[k] === false;
        }) &&
        Object.keys(cd.end_time_errors).every((k) => {
          return cd.end_time_errors[k] === false;
        });
      if (!errorNotExists) {
        isInvalid = true;
      }
    });
    if (isInvalid) {
      return Promise.reject(checkedDays);
    } else {
      return Promise.resolve(checkedDays);
    }
  };

  const handleSave = () => {
    validateTime()
      .then((selectedDays) => {
        let formattedSelectedDays = selectedDays.flatMap((singleDay) => [
          {
            working_day: singleDay.workingDay,
            start_time: singleDay.start_time.format("HH:mm"),
            end_time: singleDay.end_time.format("HH:mm"),
          },
        ]);
        formInstance.setFieldsValue({
          [`shift_${currentRoleIndex}_${currentEmployeeIndex}`]:
            formattedSelectedDays,
        });
        closeDropDown();
      })
      .catch((erroredDays) => {});
  };

  return (
    <div className="shiftTimingDropDown">
      <Row gutter={14} className="heading mb-1">
        <Col span={2}></Col>
        <Col span={6}>Day</Col>
        <Col span={8}>Start Time</Col>
        <Col span={8}>End Time</Col>
      </Row>
      {scheduleList.map((field, index) => (
        <Row key={index} gutter={14} className="shiftTimingList">
          <Col span={2}>
            <Checkbox
              checked={field.checked}
              onChange={(e) =>
                onCheckboxChange({
                  isChecked: e.target.checked,
                  index,
                  field,
                })
              }
              popupClassName="shiftTimePicker"
            />
          </Col>
          <Col span={6}>
            <Tag className={field.checked && "activeDay"}>
              {field.workingDay}
            </Tag>
          </Col>
          <Col span={8}>
            <TimePicker
              use12Hours
              minuteStep={15}
              value={field.start_time}
              showSecond={false}
              allowClear={false}
              format="h:mm a"
              suffixIcon={null}
              disabledHours={() => getDisabledHours()}
              onSelect={(time) =>
                handleTimeChange({
                  field,
                  index,
                  time,
                  type: "start_time",
                })
              }
              popupClassName="shiftTimePicker"
            />
          </Col>
          <Col span={8}>
            <TimePicker
              use12Hours
              minuteStep={15}
              value={field.end_time}
              allowClear={false}
              showSecond={false}
              format="h:mm a"
              suffixIcon={null}
              disabledHours={() => getDisabledHours()}
              onSelect={(time) =>
                handleTimeChange({
                  field,
                  index,
                  time,
                  type: "end_time",
                })
              }
              popupClassName="shiftTimePicker"
            />
          </Col>
        </Row>
      ))}
      <Row justify="end">
        <Button
          type="primary"
          shape="round"
          size="large"
          htmlType="button"
          onClick={handleSave}
        >
          Save
        </Button>
      </Row>
    </div>
  );
};
